import { Card, CardBody, Col } from "reactstrap";
import { IconPaginationTitle } from "../../../../Constants/Constants";
import { IconListData, IconPageSubTitle } from "../../../../Data/BonusUi/Pagination";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DefaultPaginationList from "../Common/DefaultPaginationList";

const IconPagination = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={IconPaginationTitle} span={IconPageSubTitle} />
        <CardBody>
          <DefaultPaginationList pageColor="secondary" data={IconListData} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default IconPagination;
